export const isSidebarCollapsed = (state) => state.sideBar.isCollapsed;
